<template>
  <view class="backgroundConent">
    <view class="navbarBg"> <es-navbar title="密码找回"></es-navbar></view>
    <!-- <block wx:if="{{__mpx_mode__ === 'web'}}">
      <view class="goPageBack" bindtap="goHome"></view>
    </block> -->
    <view class="es-input-tips">请输入您注册12306帐号时使用的手机号码</view>
    <view class="backgroundStyle">
      <view class="es-background-card">
        <view class="inputContainerStyle">
          <view class="messageStyle"> 手机号码 </view>
          <view class="es-input-id-number">
            <input
              wx:style="width: 100%"
              type="text"
              class="inputStyle"
              placeholder="请输入已经核验手机号"
              wx:model="{{phoneInput}}"
              maxlength="{{11}}"
            />
            <!-- <view class="es-retrieval-error" wx:if="{{phoneInputStatus}}"
              >请输入正确的手机号码</view
            > -->
          </view>
        </view>
        <view class="inputContainerStyle">
          <view class="messageStyle"> 新密码 </view>
          <view class="es-input-id-number">
            <input
              wx:style="width: 100%"
              type="{{passwordType}}"
              class="inputStyle"
              placeholder="不少于6位"
              wx:model="{{password}}"
            />
            <!--  bindblur="inputBlurPassword" -->
            <view class="es-retrieval-error" wx:if="{{passwordInputStatus}}">密码不能为空</view>
            <view class="icon-eye-close" bindtap="eyehandle">
              <block wx:if="{{!eyeState}}"
                ><image
                  src="https://pt-starimg.didistatic.com/static/starimg/img/LpvhCITOpN1642147541419.png"
                  class="es-eye"
                ></image
              ></block>
              <block wx:else>
                <image
                  src="https://pt-starimg.didistatic.com/static/starimg/img/FLGAZitaXS1642147590072.png"
                  class="es-eye"
                ></image
              ></block>
            </view>
          </view>
        </view>
        <view class="inputContainerStyle">
          <view class="messageStyle"> 确认密码 </view>
          <view class="es-input-id-number">
            <input
              wx:style="width: 100%"
              type="{{passwordType}}"
              class="inputStyle"
              placeholder="请再次输入密码"
              wx:model="{{confirmPassword}}"
              autocomplete="off"
            />
            <view class="es-retrieval-error" wx:if="{{confirmPasswordStatus}}">密码不能为空</view>
          </view>
        </view>
        <view class="inputContainerStyle">
          <view class="messageStyle"> 验证码 </view>
          <input
            type="text"
            class="inputStyle"
            placeholder="请输入短信验证码"
            wx:model="{{vCode}}"
            maxlength="{{6}}"
          />

          <view wx:if="{{show}}" class="es-get-code" bindtap="getCode">获取验证码</view>
          <view wx:if="{{!show}}" class="es-get-code es-get-code-gray"
            >{{ auth_time }}秒后重新发送</view
          >
        </view>
        <!-- <es-button type="info" round size="large" bind:click="goPage('list')"
        >跳转到下一个页面</es-button
      > -->
      </view>
    </view>
    <view class="footer">
      <view class="es-next-step-content">
        <view class="es-next-step">
          <!-- <view class="buttonStyle" wx:class="{{actives}}" bindtap="onClick">提交</view> -->
          <view class="buttonStyle" bindtap="onClickSubmit">提交</view>
          <!-- {{ getRequest_id }} -->
        </view>
      </view>
    </view>

    <!-- <es-navbar title="密码找回"></es-navbar> -->
    <es-dialog
      show="{{ showDialog }}"
      confirmButtonText="知道了"
      bind:confirm="toLoginPage"
      bind:close="close"
      showClass="{{true}}"
      align="center"
      class="es-modi-dialog"
    >
      <view slot="title">
        <view class="es-modi-icon"><es-icon name="check-circle-filled" size="50"/></view>
        <view>密码修改成功</view>
      </view>
      <view slot="content" class="es-dialog-content">
        <view>请重新登录</view>
      </view>
    </es-dialog>
  </view>
</template>


<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { getRetrievePassword } from '@/api/login12306'
  import { AES_ECB_ENCRYPT, AES_ECB_DECRYPT } from '@/common/crypto' // encrypt 加密
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'
  import { MOBILE_CHECK_REG } from '@/common/constant'
  // import config from '@/api/isTypeList'
  import store from '@/store'
  import { RSA2_ENCRYPT } from '../../common/rsa_crypto'
  import { innerRouter, pagePath } from "@/common/jump";
  createPage({
    data: {
      phoneInput: '',
      password: '',
      confirmPassword: '',
      vCode: '',
      isShowDialog: false,
      activeHover: true,
      idNumberHover: true,
      eyeState: false,
      auth_time: 120, //倒计时默认120s
      show: true, //默认显示获取验证码按钮
      phoneInputStatus: false,
      passwordInputStatus: false,
      confirmPasswordStatus: false,
      auth_timetimer:null
    },
    watch: {
      // retrievalCode: {
      //   handler(val, old) {
      //     console.log(val, '2222222222222')
      //     const type = val === '0' ? true : false
      //     this.isShowDialog = type
      //   }
      // }
    },
    onHide() {
      this.hideTime = new Date().getTime()
      this.stopTime('暂停')

    },
    onShow(){
      this.showTime = new Date().getTime()
      this.diffSeconds = Math.floor((this.showTime - this.hideTime)/1000)
      console.log(this.diffSeconds,this.auth_time);
      this.auth_time = this.auth_time - this.diffSeconds
      if(this.auth_timetimer) this.stopTime('开始')
      
    },
    computed: {
      ...store.mapState({
        retrievalCode: 'login12306.retrievalCode',
        accountInfo12306: 'login12306.accountInfo12306',
        getRequest_id: 'login12306.request_id'
      }),
      actives() {
        const { activeHover } = this
        if (
          this.phoneInput.length &&
          this.password.length &&
          this.confirmPassword.length &&
          this.vCode.length
        ) {
          this.activeHover = false
          return {
            'button-not-active': false
          }
        } else {
          this.activeHover = true
          return {
            'button-not-active': true
          }
        }
      },
      idNumberComputed() {
        return {
          'not-hover': this.idNumberHover
        }
      },
      passwordType() {
        const type = this.eyeState ? 'text' : 'password'
        return type
      },
      showDialog() {
        return this.retrievalCode === '0'
      }
      // inpNum: {
      //   get: function() {
      //     return this.vCode
      //   },
      //   set: function(newValue) {
      //     this.vCode = newValue.replace(/[^\d]/g, '')
      //   }
      // }
    },
    methods: {
      ...store.mapActions({
        sendCaptchaResultAction: 'login12306.sendCaptchaResultAction'
      }),
      ...store.mapMutations({
        requestIdMutation: 'login12306.requestIdMutation',
        sendCaptchaResult: 'login12306.sendCaptchaResult'
      }),
      goHome() {
        if (__mpx_mode__ !== 'web') {
          innerRouter.goback()
        } else {
          window.location.replace(pagePath().PASSWORDRETRIEVAL)
        }
      },
      eyehandle() {
        if (this.eyeState) {
          this.eyeState = false
        } else {
          this.eyeState = true
        }
      },
      showTravelQuota() {
        this.isShowDialog = true
      },
      toLoginPage() {
        this.sendCaptchaResult({
          code: null
        })
        //如果登录成功，那返回两级页面 就到了登录页面了，不需要再去push
        wx.navigateBack({
          delta: 2
        })
      },
      inputBlurPhone() {
        const telStr = /^[1]([1-9])[0-9]{9}$/
        if (this.phoneInput.trim().length) {
          const tlel = !telStr.test(this.phoneInput)
          if (tlel) {
            mpx.showToast({
              title: '请输入正确的手机号码',
              icon: 'error'
            })
            // 不符合手机格式的提示
            this.phoneInputStatus = true
            return false
          }
          this.phoneInputStatus = false
          return true
        } else {
          mpx.showToast({
            title: '请输入手机号',
            icon: 'error'
          })
          this.phoneInputStatus = true
          return false
        }
      },
      checkPassord(password){
        const validateConf = /^(?!\d+$)(?![a-zA-Z]$)(?!\_$)[\da-zA-Z_]+$/
        return validateConf.test(password)
      },
      inputBlurPassword() {
        this.passwordInputStatus = !(this.password.trim().length && this.checkPassord(this.password))
      },
      inputBlurConfirmPassword() {
        this.confirmPasswordStatus = !(this.confirmPassword.trim().length && this.checkPassord(this.confirmPassword))
      },
      close() {
        this.isShowDialog = false
      },
      goPage(type) {
        //跳转到下一个页面
        const options = {
          list: {}
        }
        const urls = {
          list: pagePath().PAGESINDEX
        }
        innerRouter.push(urls[type], options[type])
      },
      onClickSubmit() {
        const blurInputTest = this.inputBlurPhone()
        if (!blurInputTest) {
          return false
        }
        if (this.password.trim().length === 0) {
          mpx.showToast({
            title: '请输入密码',
            icon: 'error'
          })
          this.passwordInputStatus = true
          return false
        } else {
          this.passwordInputStatus = false
        }

        if (this.confirmPassword.trim().length === 0) {
          mpx.showToast({
            title: '请输入密码',
            icon: 'error'
          })
          this.confirmPasswordStatus = true
          return false
        } else {
          this.confirmPasswordStatus = false
        }
        if (this.vCode.trim().length === 0) {
          mpx.showToast({
            title: '请输入验证码',
            icon: 'error'
          })
          return false
        }
        if (this.password.trim().length < 6 || this.confirmPassword.trim().length < 6) {
          mpx.showToast({
            title: '请检查密码是否大于6位',
            icon: 'error'
          })
          return false
        }
        if (this.password.trim() !== this.confirmPassword.trim()) {
          mpx.showToast({
            title: '请于新密码保持一致',
            icon: 'error'
          })
          return
        }
        if (/[\u4E00-\u9FA5]/g.test(this.password.trim())) {
          mpx.showToast({
            title: '密码不能包含中文',
            icon: 'error'
          })
          return
        }
        if (!this.checkPassord(this.password.trim())) {
          mpx.showToast({
            title: '密码必须为字母、数字或下划线中的两种类型',
            icon: 'error'
          })
          return
        }
        if (!this.getRequest_id.trim().length) {
          mpx.showToast({
            title: '验证码输入错误',
            icon: 'error'
          })
          return
        }
        if (
          !this.vCode.trim().length ||
          this.vCode.trim().length < 6 ||
          !/^[0-9]*$/g.test(this.vCode.trim())
        ) {
          mpx.showToast({
            title: '验证码输入错误', //提示的内容,
            icon: 'error', //图标,
            duration: 2000, //延迟时间,
            mask: true, //显示透明蒙层，防止触摸穿透,
            success: (res) => {}
          })
          return false
        }
        this.sendCaptchaResultAction({
          request_id: this.getRequest_id, // this.captchaResult?.request_id,
          captcha: this.vCode
        })
      },
      //倒计时方法
      countdown(){
        if(this.auth_time>0){ //最大时间大于0
          this.auth_time--
          console.log(this.auth_time)
        }else{
          this.show = true
          clearInterval(this.auth_timetimer);
         
        }
      },
      //开始倒计时
      startCountdown(){
        this.auth_time = 120
        this.show = false //显示倒计时按钮
        const that = this
        this.auth_timetimer = setInterval(() => {
          this.countdown()
        }, 1000)
      },
      //终止倒计时
      closeTime(){
        this.auth_time=''
        clearInterval(this.timers);
      },
       //暂停开始
      stopTime(stopText){
        if(stopText==="暂停"){
          clearInterval(this.auth_timetimer);
        }else if(stopText==="开始"){
          this.auth_timetimer=setInterval(()=>{
            this.countdown()
          },1000)
        }
      },
      // 调用验证码获取倒计时方法
      getCode() {
        const that = this
        if (!this.phoneInput.trim().length) {
          mpx.showToast({
            title: '手机号码不能为空', //提示的内容,
            icon: 'error', //图标,
            duration: 2000, //延迟时间,
            mask: true, //显示透明蒙层，防止触摸穿透,
            success: (res) => {}
          })
          return false
        }
        if (!MOBILE_CHECK_REG.test(this.phoneInput.trim())) {
          mpx.showToast({
            title: '请填写正确的手机号码', //提示的内容,
            icon: 'error', //图标,
            duration: 2000, //延迟时间,
            mask: true, //显示透明蒙层，防止触摸穿透,
            success: (res) => {}
          })
          return false
        }
        if (this.password.trim() !== this.confirmPassword.trim()) {
          mpx.showToast({
            title: '请于新密码保持一致',
            icon: 'error'
          })
          return
        }
        if (this.password.trim().length < 6 || this.confirmPassword.trim().length < 6) {
          mpx.showToast({
            title: '请检查密码是否大于6位',
            icon: 'error'
          })
          return false
        }

        if (/[\u4E00-\u9FA5]/g.test(this.password.trim())) {
          mpx.showToast({
            title: '密码不能包含中文',
            icon: 'error'
          })
          return
        }
        if (!this.checkPassord(this.password.trim())) {
          mpx.showToast({
            title: '密码必须为字母、数字或下划线中的两种类型',
            icon: 'error'
          })
          return
        }
        if (
          this.phoneInput.trim().length &&
          this.password.trim().length &&
          this.confirmPassword.trim().length
        ) {
          //每隔一秒执行一次auth_time--，当auth_time的值<=0，显示获取验证码按钮，清除定时器，auth_time重新赋值为120s
          this.startCountdown()
          // 获取验证码
          this.getCodeData()
        } else {
          mpx.showToast({
            title: '手机号码不能为空', //提示的内容,
            icon: 'error', //图标,
            duration: 2000, //延迟时间,
            mask: true, //显示透明蒙层，防止触摸穿透,
            success: (res) => {}
          })
        }
      },
      // 获取验证码
      getCodeData() {
        const that = this
        getRetrievePassword({
          password: RSA2_ENCRYPT(this.password?.trim()),
          id_type: this.accountInfo12306['id_type'], // 证件类型
          id_no: AES_ECB_ENCRYPT(this.accountInfo12306['id_no']), // 证件号码
          phone: AES_ECB_ENCRYPT(this.phoneInput?.trim())
        })
          .then((res) => {
            const { data, success, message, code } = res
            if (code == '0') {
              this.requestIdMutation({
                request_id: data.request_id
              })
              mpx.showToast({
                title: '验证码已发送， 请注意查收', //提示的内容,
                icon: 'success', //图标,
                duration: 2000, //延迟时间,
                mask: true, //显示透明蒙层，防止触摸穿透,
                success: (res) => {}
              })
            } else {
              // this.requestIdMutation({
              //   request_id: data.request_id // '1125914154386257' // data.request_id
              // })
              mpx.showToast({
                title: message, //提示的内容,
                icon: 'error', //图标,
                duration: 2000, //延迟时间,
                mask: true, //显示透明蒙层，防止触摸穿透,
                success: (res) => {}
              })
            }
          })
          .finally(() => {
            mpx.hideLoading()
          })
      }
    },
    mounted() {}
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .goPageBack
    position absolute
    left 0px
    top 2px
    z-index 999
    width 100%
    height 60px
  .backgroundConent
    background-color #F0F1F4
    height 100%
  .navbarBg
    background-color $train-color-fff
  .es-content-hover
    color $train-color-theme-blue
  .es-background-card
    background #ffffff
    border-radius 8px
    padding 5px 0px 0px 5px
  .tab-label
    padding 0 5px
    position absolute
    font-size 10px
    height 18px
    line-height 18px
    color #ffffff
    background #FD6C19
    border-radius 9px
    border 1px solid #ffffff
  .backgroundStyleBox
    display flex
    flex-direction column
    justify-content space-between
    box-sizing border-box
    background-color $train-color-background
  .backgroundStyle
    padding 12px
    background-color $train-color-background
  .title
    margin-left 10px
    padding 10 20
    color black
    font-size 20px
    text-align center
    background #FD6C19
    border 1px solid #FFFFFF
    width 250px
    height 25px
  .titleStyle
    padding-top 0
    padding-bottom 12px
    color #000000
    font-size 16px
  .titleStyles
    padding-top 24px
    padding-bottom 12px
    color #000000
    font-size 16px
  .contentStyle
    color $train-color-666
    font-size 14px
  .messageStyle
    color $train-color-333
    font-size 15px
    display inline-block
    width 70px
  .messageBorder
    color #C0C0C0
    padding 0 10px
  .buttonStyle
    margin-top 16px
    color white
    background $train-color-theme-blue
    font-size 16px
    border-color $train-color-theme-blue
    padding 10px 10px
    text-align center
    border-radius 8px
  .search
    color $train-color-divider-ccc
    font-size 15px
    height 44px
    padding 13px
    width 100%
    outline none
    box-sizing border-box
  .inputContainerStyle
    padding 10px
    display flex
    align-items center
    width 100%
    box-sizing border-box
    position relative
    height 55px
  .inputStyle
    font-size 15px
    color $train-color-666
    outline none
    width 250px
    height 21px
  .inputStyle::placeholder
    color $train-color-999
  .button-not-active
    background $train-color-divider-ccc
  .es-next-step
    height 80px
    background #ffffff
    padding 0px 16px
  .es-next-box
    width 30px
    height 25px
    position absolute
    right 0
    top 10px
    color $train-color-666
  .es-input-id-number
    position relative
    width 250px
  .es-input-id-number:after
    content ' '
    display block
    width 100%
    height 1px
    background RGB(240, 241, 244)
    position absolute
    left 0
    top 38px
    z-index 1
  .es-retrieval-error
    color #f00
    position absolute
    left 0px
    top 21px
    font-size 13px
    width 100%
    border-bottom 1px red solid
  .not-hover
    display none
  .icon-eye-close
    position absolute
    width 20px
    height 20px
    right 0px
    top 1px
    z-index 99
  .es-eye
    width 20px
    height 20px
  .es-get-code
    border 1px RGB(20, 115, 255) solid
    border-radius 6px
    padding 5px
    position absolute
    right 20px
    top 13px
    font-size 13px
    color $train-color-theme-blue
    z-index 99
  .es-get-code-gray
    color $train-color-999
    border 1px solid $train-color-999
  .hidden
    display none
  .es-input-tips
    color #247CFF
    font-size 14px
    background-color #EDF4FF
    background linear-gradient(left right, #EDF4FF, #ffffff)
    padding 10px 12px
  .es-modi-icon
    height 50px
    text-align center
    color $train-color-theme-blue
  .es-next-step-content
    position absolute
    width 100%
    bottom 0px
    background $train-color-fff
    z-index 10
</style>

<script name='json'>
  module.exports = {
    component: true,
    // navigationBarTitleText: '短信核验',
    usingComponents: {
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-dialog': '@didi/es-mpx-ui/lib/dialog',
      'drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
      'es-icon': '@didi/es-mpx-ui/lib/icon'
    }
  }
</script>